import { render, staticRenderFns } from "./ListBillDeleted.vue?vue&type=template&id=6072f3bf&"
import script from "./ListBillDeleted.vue?vue&type=script&lang=js&"
export * from "./ListBillDeleted.vue?vue&type=script&lang=js&"
import style0 from "./ListBillDeleted.vue?vue&type=style&index=0&id=6072f3bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports